import React from 'react';

export default class BackButton extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.onClick) {
            return null;
        }
        //  TODO: Fix sr-only when doing accessibility
        return (
            <div className="backButton">
                <button onClick={this.props.onClick} className="backButton__button btn btn-link">
                    <span className="icon icon-left-open-big" />
                    <span className="backButton__accessible sr-only">Go back</span>
                </button>
            </div>);
    }
}

BackButton.propTypes = {
    onClick: React.PropTypes.func
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/BackButton.jsx